import type { PopoverPlacement } from "./types";

/** 下拉展开：0.8→1 + opacity，iOS 风格 spring */
export const POPOVER_SPRING_OPEN_TRANSITION = {
  type: "spring" as const,
  stiffness: 400,
  damping: 30,
  mass: 0.85,
};

/** 收起：快速缩小 + 淡出 */
export const POPOVER_SPRING_CLOSE_TRANSITION = {
  duration: 0.12,
  ease: [0.4, 0, 1, 1] as const,
};

export const popoverSpringContentMotion = {
  initial: { opacity: 0, scale: 0.8 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: POPOVER_SPRING_OPEN_TRANSITION,
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: POPOVER_SPRING_CLOSE_TRANSITION,
  },
};

/** 与 floating-ui placement 对齐的缩放原点（贴近触发按钮） */
export function getPopoverTransformOrigin(placement: PopoverPlacement): string {
  const [side, align] = placement.split("-") as [string, string | undefined];

  if (side === "top") {
    if (align === "end") {
      return "bottom right";
    }
    if (align === "start") {
      return "bottom left";
    }
    return "bottom center";
  }

  if (side === "left") {
    return align === "end" ? "center right" : "center left";
  }

  if (side === "right") {
    return align === "end" ? "center right" : "center left";
  }

  // bottom (default)
  if (align === "end") {
    return "top right";
  }
  if (align === "start") {
    return "top left";
  }
  return "top center";
}
